// extracted by mini-css-extract-plugin
module.exports = {"syncButtonWrapper":"syncButtonWrapper--2vvAJ","syncButton":"syncButton--1Eple","syncButtonSyncing":"syncButtonSyncing--3WRuR","timeUnit":"timeUnit--1yFjw","spin":"spin--2rL4P"};